
/****************ELEMENTS*****************/
//this obj define, the actions realeted to each 
//th>table header and td

export const tableDetail = {
    entity: 'otherexpense',//name table on the db
    dest: 'otherexpense',//name of the entity on the system

    //action for body 
    //left click, directly to the fullcont 
    tdDataDetail:`data-detail='{ "click": [ {"dest":"ripple" },
                                            {"dest":"otherexpense", "elem":"fullcont", "id":"otherexpense-fullcont", "act":"selectOne", "entity":"otherexpense", "dbid": "#dbid"}  ],
                                
                                 "clickRight": [{"dest":"otherexpense", "elem":"dt", "act":"trMenu", "id":"trMenu",  "entity":"otherexpense", "dbid": "#dbid" } ]  }'`,

    filter: {
        mainFilterFields : ["otherexpense.code","provider.name"],
        mainFilterValues : ["", ""],         
        andFilterFields  : [""],
        andFilterValues  : [""],  
    }

}



/****************ELEMENTS*****************/



//each element could organize their data diferent
export function organizeRow(data){ //console.log('organizeRow>')

    var newData = []

    if(data.length === 0){
        newData.push({   id: 'nothing', colum: [{ label:'No Results', span: ''},
                                                { label:'', span: '' },
                                                { label:'', span: '' },
                                                { label:'', span: '' }] })
        return newData
    }

    data.forEach((elem)=>{

        let elemName    = "";
        let letter      = "";
        let avatarColor = "";
        let avatar      = "";

        if (elem.provider_avatar == "") {
            avatar = "";
            elemName = elem.provider_name;
            
            // Dividir el nombre en palabras
            let nameParts = elemName.split(" ");

            // Filtrar las palabras para eliminar las que no empiezan con letras (ej. '&')
            let validParts = nameParts.filter(part => /^[A-Za-z]/.test(part));
            
            // Tomar la primera letra de cada palabra (si la palabra existe)
            if (validParts.length > 0) {
                letter += validParts[0].charAt(0); // Primera letra del primer nombre
            }
            if (validParts.length > 1) {
                letter += validParts[1].charAt(0); // Primera letra del segundo nombre
            }
        } else {
            avatar = elem.provider_avatar;
            elemName = "";
            letter = "";
        }

        if (elem.avatarColor == "") {
            avatarColor = '12af45'
        }else{
            avatarColor = elem.avatarColor
        }

        newData.push(
            {   id: elem.id,   colum: [  { label: elem.provider_name, span: elem.code,
                                            style:{ 
                                                tdClass:'tdWithAvatar',  
                                                avatar:avatar,
                                                avatarColor: avatarColor, 
                                                avatarLetter: letter.toUpperCase()
                                                
                                            }
                                         },  
                                         { label: elem.accounts_bank_name, span: elem.reference_number,
                                            style:{ 
                                                tdClass:'tdWithAvatar',  
                                                avatar:elem.accounts_bank_avatar, 
                                                
                                            }
                                         },    
                                         { label: elem.amount_dt, span: elem.date_td},    
                                         { label: elem.accounts_expense_name, span: '',
                                         style:{ 
                                            tdClass:'tdWithAvatar',  
                                            avatar:elem.accounts_expense_avatar, 
                                            
                                        }
                                         }]    
            }
        )/*push*/
    })/*forEach*/

    return newData
}/*organizeRow*/